import SVG from './SVG';

export default SVG;
